import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { authGuard } from './auth.guard';

export const routes: Routes = [
    {
        path: '',
        children:[
            {
                path:'',
                loadComponent:() => import('./landing-page/landing-page.component').then(m => m.landingPageComponent)
            },
            {
                path:'auth',
                loadComponent:() => import('./auth/auth.component').then(m => m.AuthComponent)
            },
            {
                path:'otp',
                loadComponent:() => import('./auth/otp/otp.component').then(m => m.OTPComponent)
            },
            {
                path:'requests-closed',
                loadComponent:() => import('./Pages/requests-closed/requests-closed.component').then(m => m.RequestsClosedComponent)
            }
        ]

    },
    {
        path:'request',
        canActivate:[authGuard],
        component:LayoutComponent,
        children:[
            {
                path:'',
                loadComponent:() => import('./Pages/request/request.component').then(m => m.RequestComponent)
            }
        ]
    },
    {
        path:'request-submitted',
        canActivate:[authGuard],
        component:LayoutComponent,
        children:[
            {
                path:'',
                loadComponent:() => import('./Pages/request-submitted/request-submitted.component').then(m => m.RequestSubmitedComponent)
            }
        ]
    },
];

